import { useMutation } from '@tanstack/react-query';
import { useQueryCacheManager } from '../../hooks/useQueryCacheManager';
import useApi from '../../api/backendApiContext';
import { useNotification } from '../../notification/notificationsContext';
import { Customer } from '../types';
import useAnalytics from '../../web-analytics/webAnalyticsContext';
import { analyticsTrack } from '../../web-analytics/webAnalytics';
import { AnalyticsEvent } from '../../web-analytics/AnalyticsEvent';

export const useRevertCancellationMutation = () => {
  const queryCacheManager = useQueryCacheManager();
  const { billingApi } = useApi();
  const { notifySuccess, notifyError } = useNotification();
  const analytics = useAnalytics();

  return useMutation<Customer, unknown, void>(async () => billingApi.revertCancellation(), {
    // eslint-disable-next-line no-unused-vars,@typescript-eslint/no-unused-vars
    onSuccess: async (customer: Customer) => {
      await queryCacheManager.invalidateBillingCustomer();
      await queryCacheManager.invalidateInvoices();
      notifySuccess({
        notificationMsg: 'Your subscription has been resumed.',
      });

      analyticsTrack(analytics, AnalyticsEvent.BILLING_PLAN_RESUMED);
    },
    onError: async () => {
      await queryCacheManager.invalidateBillingCustomer();
      await queryCacheManager.invalidateInvoices();

      notifyError({
        notificationMsg: 'Failed to resume subscription. Please try again or contact support.',
      });
    },
  });
};
